export enum ETableModes {
	BROWSE = 'BROWSE',
	DETAIL = 'DETAIL',
	UPDATE = 'UPDATE',
	INSERT = 'INSERT',
	INSERTPREF = 'INSERTPREF'
}

export type TTableModes = ETableModes.BROWSE | ETableModes.DETAIL | ETableModes.UPDATE | ETableModes.INSERT | ETableModes.INSERTPREF;

export enum EChangeActualRecord {
	FIRST = 'FIRST',
	UP = 'UP',
	DOWN = 'DOWN',
	LAST = 'LAST',
	PAGE_DOWN = 'PAGE_DOWN',
	PAGE_UP = 'PAGE_UP'
}

export enum ETablePositions {
	INVISIBLE = 'INVISIBLE',
	ALONE = 'ALONE',
	MASTER = 'MASTER',
	CHILD = 'CHILD'
}

export enum EColumnFilterModes {
	INTERVAL = 'INTERVAL',
	VALUE = 'VALUE',
	CHECK_BOXES = 'CHECK_BOXES'
}